import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "../data/content";
import { Reveal, Eyebrow, EASE } from "./Reveal";

const Item = ({ faq, open, onToggle, index }) => (
  <div className="border-b border-[#CBA135]/30" data-testid={`faq-item-${index}`}>
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-6 py-6 text-left group"
      data-testid={`faq-toggle-${index}`}
    >
      <span className="font-serif text-xl sm:text-2xl text-[#21070D] group-hover:text-[#9C7526] transition-colors duration-300">
        {faq.q}
      </span>
      <motion.span
        animate={{ rotate: open ? 45 : 0 }}
        transition={{ duration: 0.4, ease: EASE }}
        className="shrink-0 grid place-items-center h-9 w-9 rounded-full border border-[#CBA135]/50 text-[#3F101A]"
      >
        <Plus size={18} />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: EASE }}
          className="overflow-hidden"
        >
          <p className="pb-6 pr-12 text-[#3A1219] text-lg leading-relaxed body-serif">
            {faq.a}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faqs"
      className="relative bg-[#F4EBD9] py-24 sm:py-36 px-6 sm:px-10 md:px-16"
      data-testid="faq"
    >
      <div className="max-w-4xl mx-auto">
        <div className="text-center">
          <Reveal>
            <Eyebrow className="text-[#9C7526]">FAQs</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-serif font-medium text-[#21070D] text-4xl sm:text-5xl lg:text-6xl tracking-tight">
              Questions, gently answered
            </h2>
          </Reveal>
        </div>
        <div className="mt-14">
          {FAQS.map((faq, i) => (
            <Item
              key={i}
              faq={faq}
              index={i}
              open={open === i}
              onToggle={() => setOpen(open === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
